/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AccessRule } from "./AccessRule";
import {
  AccessRuleFromJSON,
  AccessRuleFromJSONTyped,
  AccessRuleToJSON,
  AccessRuleToJSONTyped,
} from "./AccessRule";

/**
 *
 * @export
 * @interface PaginatedAccessRuleList
 */
export interface PaginatedAccessRuleList {
  /**
   *
   * @type {number}
   * @memberof PaginatedAccessRuleList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedAccessRuleList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedAccessRuleList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<AccessRule>}
   * @memberof PaginatedAccessRuleList
   */
  results: Array<AccessRule>;
}

/**
 * Check if a given object implements the PaginatedAccessRuleList interface.
 */
export function instanceOfPaginatedAccessRuleList(value: object): value is PaginatedAccessRuleList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedAccessRuleListFromJSON(json: any): PaginatedAccessRuleList {
  return PaginatedAccessRuleListFromJSONTyped(json, false);
}

export function PaginatedAccessRuleListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedAccessRuleList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] == null ? undefined : json["next"],
    previous: json["previous"] == null ? undefined : json["previous"],
    results: (json["results"] as Array<any>).map(AccessRuleFromJSON),
  };
}

export function PaginatedAccessRuleListToJSON(json: any): PaginatedAccessRuleList {
  return PaginatedAccessRuleListToJSONTyped(json, false);
}

export function PaginatedAccessRuleListToJSONTyped(
  value?: PaginatedAccessRuleList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(AccessRuleToJSON),
  };
}
